import HttpService from "./http-service";
export interface AlertsCount { ads: number, informationRequests: number }

export default class AlertService extends HttpService {
  public async getAlerts(): Promise<AlertsCount> {
    const response = await this.httpClient.get<AlertsCount>('alerts-count');

    return response.data
  }
}

